import {useCallback} from 'react'

import {rowIsExpanded} from '../../../hooks/tanstack-table/helpers/row-api'
import type {Row} from '../../../hooks/tanstack-table/helpers/types'
import {useTableInstance} from '../../../hooks/tanstack-table/providers/table-provider'
import type {MemexItemModel} from '../../../models/memex-item-model'

/** Get all visible rows in the table, filtering out rows that are hidden in collapsed groups. */
export const useGetVisibleRows = () => {
  const tableInstance = useTableInstance()
  return useCallback(() => {
    const visibleRows = tableInstance.groupedRows?.reduce((acc: Array<Row<MemexItemModel>>, group) => {
      if (rowIsExpanded(group)) {
        acc.push(...group.subRows)
      }
      return acc
    }, [])
    return visibleRows ?? tableInstance.flatRows
  }, [tableInstance])
}
